import type { LeadStatus } from "@/types/campaign";
import { cva } from "cva";

const statusIndicatorStyles = cva({
  base: "size-[9px] rounded-full",
  variants: {
    status: {
      Draft: "bg-gray-400 dark:bg-gray-600",
      Future: "bg-theme-on-background/15",
      Stopped: "bg-gradient-to-br from-red-500 to-red-400",
      Started: "bg-gradient-to-br from-green-500 to-green-400",
      New: "bg-blue-500",
      Postponed: "bg-yellow-500",
      InProgress: "bg-purple-500",
      ClosedWon: "bg-green-500",
      Handled: "bg-green-600 dark:bg-green-400",
      Used: "bg-theme-primary/30",
      Theme: "bg-gradient-to-br from-theme-primary to-theme-secondary",
    },
  },
});

type Props = {
  status:
    | Exclude<
        LeadStatus,
        | "ClosedLost"
        | "Disqualified"
        | "Scheduled"
        | "FollowUpDue"
        | "Rejected"
        | "Qualified"
        | "None"
      >
    | "Handled"
    | "Draft"
    | "Theme"
    | "Used"
    | "Future";
};

export function StatusIndicator({ status }: Props) {
  return (
    <div
      className={statusIndicatorStyles({
        status,
      })}
    />
  );
}
